<template>
  <v-container
    fluid
    class="mt-0 ml-0 mr-0 pa-0"
    style="margin-bottom:55px; background-color:#FFFFFF"
  >
    <v-row
      v-show="site_logo"
      justify="center"
      class="ma-0 pa-0"
    >
      <v-img
        :src="site_logo"
        class="mx-0 my-2 pa-0"
        max-width="150"
      />
    </v-row>
    <v-row
      justify="center"
      class="ma-0 mb-5 pa-0"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="3"
        xl="3"
        class="mt-0 mb-5"
      >
        <div
          v-show="partner_officialSite"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_officialSite"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-web
            </v-icon>
            <v-spacer />
            Official Site
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_instagram"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_instagram"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-instagram
            </v-icon>
            <v-spacer />
            Instagram
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_twitter"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_twitter"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-twitter
            </v-icon>
            <v-spacer />
            Twitter
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_facebook"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_facebook"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-facebook
            </v-icon>
            <v-spacer />
            Facebook
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_youtube"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_youtube"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-youtube
            </v-icon>
            <v-spacer />
            Youtube
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_weibo"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_weibo"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-sina-weibo
            </v-icon>
            <v-spacer />
            Weibo
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_tiktok"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_tiktok"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-music-note-eighth
            </v-icon>
            <v-spacer />
            TikTok
            <v-spacer />
          </v-btn>
        </div>
        <div
          v-show="partner_contact"
          class="pa-2"
        >
          <v-btn
            :color="site_color"
            :href="partner_contact"
            target="_blank"
            rounded
            block
            class="text-h4"
            elevation="1"
            height="50"
          >
            <v-icon
              right
              dark
              large
            >
              mdi-mail
            </v-icon>
            <v-spacer />
            Contact
            <v-spacer />
          </v-btn>
        </div>
        <div
          align="center"
        >
          <v-card-text
            class="text-h5 mt-10 pa-1"
          >
            <a
              href="https://navy-steam-ea4.notion.site/Momento-GuideLine-49df6697cb1240a3abcfda8a845a6e55"
              target="_blank"
              style="text-decoration:none; color:#222; font-size:12px;"
            >
              Terms of service
            </a>
            <span>/</span>
            <a
              href="https://navy-steam-ea4.notion.site/Momento-GuideLine-49df6697cb1240a3abcfda8a845a6e55"
              target="_blank"
              style="text-decoration:none; color:#222; font-size:12px;"
            >
              Privacy policy
            </a>
          </v-card-text>
          <v-card-text
            class ="mt-0 mb-10 pa-2"
          >
            <a
              href="https://katariji.com/"
              target="_blank"
              style="text-decoration:none; color:#222; font-weight: bold; font-size:36px;"
            >
              Momento
            </a>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { db } from '../../plugins/firebase.js'
  export default {
    name: 'Pages',
    data: () => ({
      site_color: '',
      site_logo: '',
      partner_contact: '',
      partner_facebook: '',
      partner_instagram: '',
      partner_officialSite: '',
      partner_tiktok: '',
      partner_twitter: '',
      partner_weibo: '',
      partner_youtube: '',
    }),
    created () {
      this.site_logo = this.$store.state.site_logo
      this.site_color = this.$store.state.site_color
      this.getLinks()
    },
    mounted () {
      // Vuexの値が変更完了したタイミングでの通知
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'SET_SITE_LOGO') {
          this.site_logo = state.site_logo
        }
      })
    },
    methods: {
      getLinks: function () {
        db.collection('partners').doc(this.$store.state.partner_id).get().then((doc) => {
          this.partner_contact = doc.data().partner_contact
          this.partner_facebook = doc.data().partner_facebook
          this.partner_instagram = doc.data().partner_instagram
          this.partner_officialSite = doc.data().partner_officialSite
          this.partner_tiktok = doc.data().partner_tiktok
          this.partner_twitter = doc.data().partner_twitter
          this.partner_weibo = doc.data().partner_weibo
          this.partner_youtube = doc.data().partner_youtube
        }).catch(function (error) {
          console.log('error: ' + error)
        })
      },
    },
  }
</script>
